module.exports = __webpack_public_path__ + "img/physical_activity.86a7f28b.png";